/**
 * PostHog: flags multivariante para invitación premium y estilo Reels.
 *
 * Configurar en PostHog con estos keys exactos:
 * - `premium_invite_layout` → variantes: `reels_feed` | `premium_simple`
 *   (alias aceptados en runtime: `reels`, `simple`). Boolean legacy: `true` → Reels, `false` → landing.
 * - `reels_feed_ab_style` → variantes: `three_teaser` | `classic`
 *   (alias: `three-teaser` normalizado a `three_teaser`). Si el flag no existe o el valor no es válido,
 *   `ReelsFeed` usa `abVariantFallback` (default alineado con DB/admin: `three_teaser`).
 */

export const POSTHOG_FLAG_PREMIUM_INVITE_LAYOUT = "premium_invite_layout";
export const POSTHOG_FLAG_REELS_FEED_AB_STYLE = "reels_feed_ab_style";

/** Alineado con `defaultPremiumInvitePublicConfig().reels_player_variant` en API. */
export const DEFAULT_REELS_AB_WHEN_FLAG_MISSING = "three_teaser" as const;

export function normalizePremiumInviteLayoutFlagValue(
  raw: unknown,
): "premium_simple" | "reels_feed" | null {
  if (raw === true) return "reels_feed";
  if (raw === false) return "premium_simple";
  if (typeof raw === "string") {
    const s = raw.trim().toLowerCase();
    if (s === "reels_feed" || s === "reels") return "reels_feed";
    if (s === "premium_simple" || s === "simple") return "premium_simple";
  }
  return null;
}

/**
 * Normaliza el valor multivariante del player Reels.
 * Devuelve null si falta el flag o el valor no es reconocido (el caller aplica fallback).
 */
export function normalizeReelsFeedAbFlagValue(raw: unknown): "classic" | "three_teaser" | null {
  if (typeof raw !== "string") return null;
  const s = raw.trim().toLowerCase().replace(/-/g, "_");
  if (s === "three_teaser") return "three_teaser";
  if (s === "classic") return "classic";
  return null;
}
